import * as React from "react";
import { cn } from "@/lib/utils";

/**
 * WorkspaceSurface provides contained touch-safe cards on mobile 
 * and strips back to a transparent, cardless flow on desktop environments.
 */
const WorkspaceSurface = React.forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(
  ({ className, ...props }, ref) => (
    <div 
      ref={ref} 
      className={cn(
        // Mobile: Contained card approach
        "bg-white dark:bg-zinc-900/50 border border-zinc-200 dark:border-white/5 rounded-xl shadow-black/5 p-4",
        // Desktop: Transparent workspace flow
        "md:bg-transparent md:dark:bg-transparent md:border-transparent md:shadow-none md:p-0",
        className
      )} 
      {...props} 
    />
  )
);
WorkspaceSurface.displayName = "WorkspaceSurface";

const WorkspaceSection = React.forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(
  ({ className, ...props }, ref) => (
    <div 
      ref={ref} 
      className={cn("flex flex-col gap-4", className)} 
      {...props} 
    />
  )
);
WorkspaceSection.displayName = "WorkspaceSection";

const WorkspaceRow = React.forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(
  ({ className, ...props }, ref) => (
    <div 
      ref={ref} 
      className={cn(
        "flex items-center p-3 -mx-3 rounded-lg transition-colors",
        "hover:bg-zinc-50 dark:hover:bg-white/[0.03]",
        "border-b border-zinc-100 dark:border-white/[0.04] last:border-b-0",
        className
      )} 
      {...props} 
    />
  )
);
WorkspaceRow.displayName = "WorkspaceRow";

export { WorkspaceSurface, WorkspaceSection, WorkspaceRow };
